//* Libraries imports
import { useQuery } from "@tanstack/react-query";

//* Axios Import
import { privateApi } from "../../../services/apis/configs/apiClient";

//* Zod Import
import { z } from "zod";

// Schema for process edital response
const processEditalResponseSchema = z.object({
  result: z.boolean(),
  data: z.object({
    processo_id: z.number(),
    processo_name: z.string(),
    faculdade: z.object({
      id: z.number(),
      name: z.string(),
    }),
    regras: z.string(),
    updated_at: z.string(),  }),
});

/**
 * API para edital de processos
 */
const ProcessEditalAPI = {
  /**
   * Obtém os dados do edital de um processo específico pelo seu ID
   * @param id ID do processo para recuperar o edital
   * @returns Dados do edital do processo ou erro
   */
  getEditalById: async function (id: number) {
    try {      
      const response = await privateApi.get(
        `/student_portal/private/processos/get_processo/${id}/edital`
      );      const validatedResponse = processEditalResponseSchema.parse(response);

      return {
        data: validatedResponse.data,
        success: true
      };
    } catch (error) {
      console.error(`Erro ao buscar edital do processo com ID ${id}:`, error);
      return {
        data: null,
        success: false,
        message: "Não foi possível carregar o edital do processo. Tente novamente mais tarde."
      };
    }
  }
}

/**
 * Hook para obter o edital de um processo específico pelo ID
 * @param id ID do processo para recuperar o edital
 * @returns Query para dados do edital do processo
 */
export function useGetProcessEditalById(id: number) {
  return useQuery({
    queryKey: ["process-edital", id],
    queryFn: async () => await ProcessEditalAPI.getEditalById(id),
    retry: 2,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!id, 
  });
}